export default "__VITE_ASSET__B7puC0cx__"